import React, { useCallback } from 'react'

import CarouselTitle from '../CarouselTS/CarouselTitle'
import CollectionLanes from './CollectionLanes'
import CollectionLane from './CollectionLane'
import Carousel from '../CarouselTS/Carousel'
import { getCard, getCarouselLayout, isLive } from '../CarouselTS'
import { useAppSelector } from '../../hooks/useStore'

import type { CollectionsSetProps } from './types'
import type { RootState } from '../../reducers/types/reducerTypes'

const CollectionsSet = ({
  collections,
  singleRow,
  extraTts,
  avoidSeeAllCard = false,
  hasHeaderComponent = false,
  handleInfiniteFetching,
  onLeftExit,
  className = '',
}: CollectionsSetProps) => {
  const { short_common_name } = useAppSelector(
    (state: RootState) => state.station
  )

  return (
    <CollectionLanes
      collections={collections}
      singleRow={singleRow}
      hasHeaderComponent={hasHeaderComponent}
      className={className}
    >
      {useCallback(
        (collection, handleCarouselFocus, index) => {
          const isLiveCollection = isLive(collection.slug)
          const title = isLiveCollection
            ? `Watch ${short_common_name} Now`
            : collection.title
          return (
            <CollectionLane collection={collection} key={collection.slug}>
              <CarouselTitle isLive={isLiveCollection} title={title} />
              <Carousel
                collection={collection}
                layout={getCarouselLayout(collection)}
                card={getCard(collection)}
                avoidSeeAllCard={avoidSeeAllCard}
                onFocus={handleCarouselFocus}
                ttsText={extraTts ? `${extraTts} ${title}` : title}
                index={index}
                handleInfiniteFetching={handleInfiniteFetching}
                onLeftExit={onLeftExit} // TODO review if this is needed
              />
            </CollectionLane>
          )
        },
        [handleInfiniteFetching]
      )}
    </CollectionLanes>
  )
}

export default CollectionsSet
